import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const CaseGallery = ({ images, alt, fit = 'cover' }) => {
  const [i, setI] = useState(0);
  const go = (d) => setI((p) => (p + d + images.length) % images.length);
  const imgCls = fit === 'contain' ? 'object-contain' : 'object-cover';

  return (
    <div data-testid="case-gallery" className="absolute inset-0 bg-ink">
      {fit === 'contain' && (
        <img src={images[i]} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover blur-2xl opacity-40 scale-110" />
      )}
      <AnimatePresence mode="wait">
        <motion.img
          key={images[i]}
          src={images[i]}
          alt={`${alt} — ${i + 1}`}
          data-testid="case-gallery-image"
          initial={{ opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45 }}
          className={`absolute inset-0 w-full h-full ${imgCls}`}
        />
      </AnimatePresence>

      <div className="absolute inset-x-0 bottom-0 px-5 pb-5 pt-10 sm:px-6 sm:pb-6 flex items-center justify-between bg-gradient-to-t from-ink/80 to-transparent">
        <div className="flex gap-2">
          <button type="button" data-testid="case-gallery-prev" onClick={() => go(-1)} aria-label="Previous image"
            className="w-10 h-10 rounded-full bg-butter text-ink border border-ink flex items-center justify-center hover:bg-cream transition-colors">
            <ChevronLeft size={18} />
          </button>
          <button type="button" data-testid="case-gallery-next" onClick={() => go(1)} aria-label="Next image"
            className="w-10 h-10 rounded-full bg-butter text-ink border border-ink flex items-center justify-center hover:bg-cream transition-colors">
            <ChevronRight size={18} />
          </button>
        </div>
        <div className="flex items-center gap-1.5">
          {images.map((src, k) => (
            <button key={src} type="button" onClick={() => setI(k)} aria-label={`Image ${k + 1}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${k === i ? 'w-6 bg-butter' : 'w-1.5 bg-cream/50 hover:bg-cream'}`} />
          ))}
        </div>
      </div>
      <span className="absolute top-4 right-14 text-[11px] font-bold tracking-[0.2em] text-cream bg-ink/60 backdrop-blur px-2.5 py-1 rounded-full">
        {i + 1}/{images.length}
      </span>
    </div>
  );
};
